import { lazy } from 'react';

const CharityVettingAcceptsAllFoodAndNonFoodEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingAcceptsAllFoodAndNonFood" */ '../components/steps/charity-accepts-all-food-and-non-food-step/CharityAcceptsAllFoodAndNonFood'
    ),
);

export default CharityVettingAcceptsAllFoodAndNonFoodEntry;
